import { render, staticRenderFns } from "./AdminImportPolice.vue?vue&type=template&id=55b08370&scoped=true&"
import script from "./AdminImportPolice.vue?vue&type=script&lang=js&"
export * from "./AdminImportPolice.vue?vue&type=script&lang=js&"
import style0 from "./AdminImportPolice.vue?vue&type=style&index=0&id=55b08370&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b08370",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\escal\\Projects\\Betterway.Vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('55b08370')) {
      api.createRecord('55b08370', component.options)
    } else {
      api.reload('55b08370', component.options)
    }
    module.hot.accept("./AdminImportPolice.vue?vue&type=template&id=55b08370&scoped=true&", function () {
      api.rerender('55b08370', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/AdminImportPolice.vue"
export default component.exports